// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"fd7b8d25f2bc7e75","2013":"874f33570d306d0f","2048":"953cf80c47a6b8f9","3492":"8c9cb1f0df0204fe","3807":"ff15786306a85db6","7957":"67e48c4fd2e94e62"}[chunkId] + ".js";
};